import { supabase } from './supabaseClient';

export const isSupersededQuote = (quote: any) => String(quote?.status || '').toUpperCase() === 'SUPERSEDED';
export const canSupersedeQuote = (quote: any) => ['DRAFT', 'SENT'].includes(String(quote?.status || '').toUpperCase());

export async function supersedeQuote(quoteId: string): Promise<void> {
  if (!window.confirm('Mark this quote as Superseded? It will stay in your history, but its client link can no longer approve it. The event and other quotes will not change.')) return;
  const { error } = await supabase.rpc('admin_supersede_quote', { p_quote_id: quoteId });
  if (error) throw error;
}
